import * as z from "zod/v4";

export const getAgentNames = {
  name: "getAgentNames" as const,
  input: z.object({}),
  output: z.array(z.string()),
};
